import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExternalArrowRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.6 4.4q0 1.1 1.2 1.2h5.9L13.2 17.1q-.8 1 0 1.7c.4.5 1.2.5 1.6 0L26.4 7.3v5.9a1.2 1.2 0 1 0 2.4 0V4.4q0-1.1-1.2-1.2h-8.8q-1.1 0-1.2 1.2M7.2 8a4 4 0 0 0-4 4v12.8a4 4 0 0 0 4 4H20a4 4 0 0 0 4-4v-4.4a1.2 1.2 0 1 0-2.4 0v4.4q-.1 1.5-1.6 1.6H7.2q-1.5-.1-1.6-1.6V12q.1-1.5 1.6-1.6h4.4a1.2 1.2 0 1 0 0-2.4z" })
});
export default SvgExternalArrowRegularIcon;
